"use client";

import { Typography, styled } from "@mui/material";

const Heading = styled(Typography)({
  marginBottom: "32px",
});

export default Heading;